import { TranslationKeys } from '~frontend-common/i18n/english/suggestion.i18n';

const keys: TranslationKeys = {
  suggestion: {
    // Labels for insurers
    carClaimDescription: {
      collision: 'Collision',
      fire: 'Incendie',
      glassBreakage: 'Bris de vitre',
      hail: 'Grêle',
      liability: 'Responsabilité civile',
      liabilityAndCollision: 'Collision et responsabilité civile',
      otherNonResponsible: 'Autre (Non responsable)',
      theft: 'Vol',
      vandalism: 'Vandalisme',
    },

    // Keep it in blocks to make it easier to compare with Fortus documentation
    drivingConvictionDescription: {
      // Severity minor (37)
      crowdingDriversSeat: 'Trop de Passagers sur le siège conducteur',
      defectiveBrakes: 'Freins défectueux',
      distractedDriving: 'Distraction du conducteur',
      driversLicenseViolations: 'Violations du permis de conduire',
      failingToShareRoad: 'Défaut de partager la route',
      failingToSignal: 'Défaut de signaler',
      failingToYield: 'Non respect d’un cédez le passage',
      failingToYieldPedestrian: 'Non respect d’un cédez le passage piétonnier',
      failureToCarryInsuranceCard: 'Défaut de transporter une carte d’assurance',
      failureToProduceEvidenceOfInsurance: 'Défaut de fournir une preuve d’assurance',
      failureToUseSeatbelts: 'Défaut de porter la ceinture de sécurité',
      followingTooClosely: 'Non respect de la distance raisonnable',
      headlightOffenses: 'Défaut de diminuer l’intensité des phares',
      improperDividedHighway: 'Conduite imprudente ou interdite sur une route divisée',
      improperDrivingBusLane: 'Conduire dans une voie réservée aux autobus',
      improperLaneChange: 'Changement de voie imprudent ou interdit',
      improperOpeningDoor: 'Ouverture imprudente de la portière',
      improperPassing: 'Dépassement imprudent ou interdit',
      improperTowing: 'Remorquage imprudent ou interdit',
      improperTurn: 'Virage imprudent',
      insecureLoad: 'Chargement non sécuritaire',
      minorConvictionNotSpecified: 'Autre condamnation mineure',
      obstructingTraffic: 'Entrave à la circulation',
      overload: 'Surcharge',
      prohibitedHandHeldDevice: 'Utilisation d’un appareil mobile interdit (ex: téléphone)',
      railwayCrossing: 'Traverse de chemin de fer',
      speeding: 'Excès de vitesse',
      stopSign: 'Infractions reliées à un panneau d’arrêt (stop)',
      trafficLight: 'Infractions reliées à un feux de signalisation',
      trailerPassenger: 'Passager dans une remorque',
      unnecessaryNoise: 'Bruit non nécessaire',
      unnecessarySlowDriving: 'Conduite inutilement lente',
      unsafeMove: 'Déplacement dangereux ou imprudent',
      unsafeTurn: 'Virage interdit',
      unsafeVehicle: 'Véhicule non sécuritaire',
      viewObstructed: 'Vue obstruée',
      wrongWayOnOneWay: 'Conduite en sens inverse',

      // Severity major (10)
      failingReportAccident: 'Défaut de déclarer un accident',
      failureReportDamageHighway: 'Défaut de déclarer des dommages à un véhicule',
      falseStatementInsurance: 'Fausse déclaration reliée à l’assurance',
      majorConvictionNotSpecified: 'Autre condamnation majeure ',
      operateMotorVehicleWithoutInsurance: 'Conduite d’un véhicule sans assurance',
      produceFalseInsurance: 'Falsification des papiers d’assurance',
      schoolBusFailStop: 'Dépassement d’un autobus scolaire ou défaut d’arrêter',
      schoolPlaygroundImproperPassing: 'Dépassement dans une zone scolaire',
      stunting: 'Cascade ou acrobatie avec véhicule',
      vehicleOwnerWithoutInsurance: 'Propriétaire de voiture sans assurance',

      // Severity criminal (13)
      bloodAlcohol: 'Alcoolémie',
      carelessDriving: 'Conduite inattentive',
      criminalNegligence: 'Négligence criminelle',
      dangerousDriving: 'Conduite dangereuse',
      drivingWhileUnderSuspension: 'Conduire avec un permis suspendu',
      failingObeyPolice: 'Refus d’obéir à un agent de police',
      failingRemain: "Défaut de rester sur les lieux de l'accident",
      impairedDriving: 'Conduite avec facultés affaiblies',
      motorManslaughter: 'Homicide involontaire coupable relié à un véhicule',
      racing: 'Course',
      refuseBreathalyzer: 'Refus d’analyse d’haleine',
      seriousConvictionNotSpecified: 'Autre condamnation grave',
    },

    floaterTypes: {
      animal: 'Animal domestique',
      art: "Oeuvre d'art",
      bicycle: 'Bicyclette',
      collection: 'Collection',
      fur: 'Bien en fourrure',
      jewelry: 'Bijoux',
      tractor: 'Tondeuse et remorque',
      watercraft: 'Embarcation nautique',
    },

    // Financial Institutions list
    financialInstitutions: {
      alternaBank: '608 - Banque Alterna',
      alternaSavings: '842 - Caisse Alterna',
      bankofMontreal: '001 - BMO - Banque de Montréal',
      caisseAlliance: '890 - Caisse Alliance',
      canadianWesternBank: "030 - Banque Canadienne de l'Ouest",
      central1CreditUnion: '828 - Coopérative de crédit Central 1',
      cibc: '010 - CIBC - Banque Canadienne Impériale de Commerce',
      desjardinsGroup: '815 - Les caisses Desjardins du Québec',
      desjardinsOntarioCreditUnion: '829 - Caisse Desjardins Ontario',
      equitableBank: '623 - Banque Équitable',
      hsbcBank: '016 - Banque HSBC Canada',
      laurentianBank: '039 - Banque Laurentienne du Canada',
      manulifeBank: '540 - Banque Manuvie',
      meridianCreditUnion: '837 - Meridian Credit Union',
      motusbank: '374 - Motusbank',
      nationalBank: '006 - Banque Nationale',
      peoplesTrustBank: '621 - La Compagnie de Fiducie Peoples',
      presidentChoiceBank: '320 - Banque Choix du Président',
      royalBank: '003 - RBC - Banque Royale du Canada',
      scotiabank: '002 - Banque Scotia',
      tangerineBank: '614 - Banque Tangerine',
      tdBank: '004 - TD - Banque Toronto Dominion',
      vancityBank: '809 - Banque Vancity',
      wealthOneBank: '370 - Wealth One Bank',
      wealthsimple: '703 - Wealthsimple',
    },

    // Fire House distance
    fireStationDistance: {
      between8and13km: 'Entre 8 et 13km',
      over13km: 'Plus de 13km',
      within8km: 'Moins de 8km',
    },

    // Labels for claims descriptions
    homeClaimDescription: {
      airConditioner: 'Climatiseur',
      bodilyInjury: 'Blessure corporelle',
      burglary: 'Cambriolage ou vol',
      cardFraud: 'Fraude par carte de crédit',
      earthquake: 'Tremblement de terre',
      explosion: 'Explosion',
      exteriorSewerLine: "Bris canalisations d'égout extérieures",
      exteriorWaterLine: "Bris conduite d'eau extérieure",
      fire: 'Feu',
      floodWater: 'Inondations',
      glass: 'Bris de vitres',
      groundWater: "Dégâts dûs à l'eau du sol",
      identityTheft: "Vol d'identité",
      other: 'Autre',
      personalProperty: 'Dommages matériels',
      sewerBackup: "Refoulement d'égout",
      vandalism: 'Vandalisme',
      water: "Dommages causés par l'eau",
      windstorm: 'Tempête de vent ou grêle',
    },

    months: {
      april: 'Avril',
      august: 'Août',
      december: 'Décembre',
      february: 'Février',
      january: 'Janvier',
      july: 'Juillet',
      june: 'Juin',
      march: 'Mars',
      may: 'Mai',
      november: 'Novembre',
      october: 'Octobre',
      september: 'Septembre',
    },

    mortgageLenders: {
      canadaDevelopmentBank: 'Banque de développement du Canada - BDC',
      cibcBank: 'Banque Canadienne Impériale de Commerce - CIBC',
      citiBank: 'Banque CITI',
      computershareTrustCompany: 'Computershare',
      desjardinsGroup: 'Les caisses Desjardins du Québec',
      firstNational: 'Financière First National SEC',
      hscbBank: 'Banque HSBC Canada',
      industrialAlliance: 'Industrielle Alliance',
      ingBank: 'Groupe International des pays-bas - ING',
      investorsGroup: 'Groupe Investors',
      johnDeere: 'John Deere Financière',
      kubota: 'Services financiers Kubota',
      laCapitale: 'La Capitale',
      laurentianBank: 'Banque Laurentienne du Canada',
      manulifeBank: 'Banque Manuvie',
      montrealTrustCompany: 'Compagnie Montréal Trust du Canada - MTCC',
      nationalBank: 'Banque Nationale',
      peoplesTrustCompany: 'Peoples Trust Company',
      quebecInvestment: 'Investissement Québec',
      royalBank: 'Banque Royale du Canada - RBC',
      schl: "Société canadienne d'hypothèques et de logement - SCHL",
      scotiaBank: 'Banque Scotia',
      standardLife: 'Standard Life',
      tangerineBank: 'Banque Tangerine',
      tdBank: 'Banque Toronto Dominion - TD',
    },

    numberOfBathrooms: {
      one: '1',
      oneFullAndOneHalf: '1.5',
      two: '2',
      twoFullAndOneHalf: '2.5',
      // tslint:disable-next-line:object-literal-sort-keys
      three: '3',
      threeFullAndOneHalf: '3.5',
      four: '4',
      fourFullAndOneHalf: '4.5',
      five: '5',
      fiveFullAndOneHalf: '5.5',
      six: '6',
      sixFullAndOneHalf: '6.5',
    },

    occupationCategories: {
      agriculture: 'Agriculture et ressources naturelles',
      art: 'Art et design',
      communication: 'Communication et documentation',
      construction: 'Construction et production',
      customerService: 'Service à la clientèle et ventes',
      education: 'Éducation',
      engineering: 'Génie',
      finance: 'Services financiers',
      law: 'Loi et protection du public',
      maintenance: 'Entretien et manutention',
      medical: 'Santé',
      multimedia: 'Multimédia',
      publicCivilServices: 'Fonction publique',
      science: 'Science (Physique, technologie, etc)',
      socialServices: 'Services sociaux',
      transport: 'Transport et machinerie',
    },

    plumbingType: {
      abs: 'ABS',
      copper: 'Cuivre',
      copperAndAbs: 'Cuivre et ABS',
      galvanized: 'Galvanisé',
      iron: 'Fer',
      other: 'Autre',
      pex: 'PEX',
      pvc: 'PVC',
      kitec: 'Kitec',
      polyB: 'Poly-B (Polybutylène)',
    },

    // Labels for Provinces
    province: {
      alberta: 'Alberta',
      britishColumbia: 'Colombie Britannique',
      manitoba: 'Manitoba',
      newBrunswick: 'Nouveau Brunswick',
      newfoundland: 'Terre Neuve et Labrador',
      novaScotia: 'Nouvelle Écosse',
      ontario: 'Ontario',
      priceEdwardIsland: 'Île du Prince Édouard',
      quebec: 'Québec',
      saskatchewan: 'Saskatchewan',
    },

    // Labels for relationship
    relationship: {
      boyfriendOrGirlfriend: 'Chum / Blonde',
      family: 'Famille',
      marriedOrCivilUnion: 'Marié / Conjoint de fait',
      other: 'Autre',
      roomate: 'Colocataire',
    },

    // Roof type labels
    roofType: {
      asphalt: 'Bardeaux d’asphalte',
      clay: 'Tuiles d’argile ou d’ardoise',
      metal: 'Métal',
      other: 'Autre',
      rubber: 'Caoutchouc',
      tar: 'Bardeaux de bois',
      wood: 'Goudron et gravier',
    },

    // Structure damages labels
    structureDamages: {
      damaged: 'Oui, pas réparé',
      none: 'Jamais',
      repaired: "Oui, c'est réparé",
    },

    // Water hydrant distance
    fireHydrantDistance: {
      over300m: 'Plus de 300m',
      within300m: 'Moins de 300m',
    },

    // ranges for driving outside home province
    yearlyDaysOutsideOfProvince: {
      twentyOne: 'Moins de 3 semaines',
      fortyNine: '4 à 7 semaines',
      oneHundredFive: '8 à 15 semaines',
      never: 'Jamais',
      oneHundredEightyTwo: '16 à 26 semaines',
      oneHundredEightyNine: 'Plus de 26 semaines ou 6 mois',
    },

    // Uninsured reasons for home / condo
    homeUninsuredReason: {
      cancelledByInsurer: "J'ai été annulé par mon assureur précédent",
      financialIncapacity: "J'ai connu une incapacité financière",
      noMortgage: "Je n'avais pas de prêt hypothécaire, ou mon propriétaire ne l'exigeait pas",
    },

    // Uninsured reasons for car
    carUninsuredReason: {
      cancelledByInsurer: "J'ai été annulé par mon assureur précédent",
      vehiculeStored: 'Le véhicule était entreposé',
      financialIncapacity: "J'ai connu une incapacité financière",
      newPurchaseOrTransfer: "C'est un nouvel achat / transfert de propriété",
    },
  },
};

export default keys;
